var TABLE_ACTION_CLICK = 'TABLE_ACTION_CLICK';
var TABLE_ADD_NEW_ROW = 'TABLE_ADD_NEW_ROW';
var TABLE_ROW_CLICK = 'TABLE_ROW_CLICK';
var TABLE_COLUMN_FIELD_BLUR = 'TABLE_COLUMN_FIELD_BLUR';
var TABLE_ROWS_ORDER_CHANGE = 'TABLE_ROWS_ORDER_CHANGE';
var TABLE_ACTION_TYPES = {
  TABLE_ACTION_CLICK: TABLE_ACTION_CLICK,
  TABLE_ADD_NEW_ROW: TABLE_ADD_NEW_ROW,
  TABLE_ROW_CLICK: TABLE_ROW_CLICK,
  TABLE_COLUMN_FIELD_BLUR: TABLE_COLUMN_FIELD_BLUR,
  TABLE_ROWS_ORDER_CHANGE: TABLE_ROWS_ORDER_CHANGE
};
export default TABLE_ACTION_TYPES;